import {
  useWSModalCustom,
  useWSSnackbar,
  WSAlert,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { queriesWorkLogs } from "@query";

type Props = {
  workLogId: string;
} & WSModalCustomProps<{
  createError?: boolean;
}>;

export const ModalConvert: React.FC<Props> = ({ workLogId, ...props }) => {
  const history = useHistory();
  const { openSnackbar } = useWSSnackbar();
  // TODO(v3): the v1 POST /convert endpoint was removed. Approving a work log on
  // v3 synchronously produces the invoice/pay-statement (provenance on
  // `WorkLog.convertedResourceId`); the v1 `invoiceStatus` query param is dropped.
  const [mutate, meta] = queriesWorkLogs.approveWorkLog.useMutation();

  return (
    <WSModal
      title="Create invoice"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Back",
            onClick: () => {
              props.onClose({ createError: false });
            }
          },
          {
            kind: "Primary",
            label: "Create invoice",
            onClick: () => {
              mutate(
                { workLogId },
                {
                  onSuccess: workLog => {
                    history.push(
                      `/member/invoices/${workLog.convertedResourceId}`
                    );
                    props.onClose({ createError: false });

                    openSnackbar({
                      icon: {
                        name: "check"
                      },
                      message: "Invoice created"
                    });
                  },
                  onError: () => {
                    props.onClose({ createError: true });
                  }
                }
              );
            },
            loading: meta.isLoading
          }
        ]
      }}
      {...props}
    >
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Create an invoice from this work log?
        </WSText.ParagraphSm>
        <WSAlert theme="info" title="What happens next" icon="info-circle">
          <WSInfoBox transparent>
            <p>
              Make sure all work log details are accurate before proceeding.
            </p>
            <ul>
              <li>
                An invoice will be created in "Open" status and sent to your
                client for approval.
              </li>
              <li>The work log will be locked and cannot be edited.</li>
              <li>
                If you need to make changes, you'll need to request to have the
                unpaid invoice cancelled to edit the work log.
              </li>
            </ul>
          </WSInfoBox>
        </WSAlert>
      </WSList>
    </WSModal>
  );
};

export const useModalConvert = () => useWSModalCustom(ModalConvert);
